import React from 'react';
import PropTypes from 'prop-types';

class Camera extends React.Component {
  static propTypes = {
    videoWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    videoHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    screenshotFormat: PropTypes.oneOf([
      'image/webp',
      'image/png',
      'image/jpeg'
    ]),
    screenshotQuality: PropTypes.number,
    onCapture: PropTypes.func
  };

  static defaultProps = {
    videoWidth: 960,
    videoHeight: 720, // 720p
    screenshotFormat: 'image/jpeg',
    screenshotQuality: 1
  };

  constructor(props) {
    super(props);

    this.capture = this.capture.bind(this);
  }

  componentDidMount() {
    this.props.captureHandler(this.capture.bind(this));

    if (!this.hasGetUserMedia()) return;

    this.requestUserMedia();
  }

  componentWillUnmount() {
    this.stopStream();
  }

  hasGetUserMedia() {
    return !!(
      (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia
    );
  }

  requestUserMedia() {
    const userMediaConstraints = { video: true };
    const userMedia =
      navigator.mediaDevices.getUserMedia(userMediaConstraints) ||
      navigator.webkitGetUserMedia(userMediaConstraints) ||
      navigator.mozGetUserMedia(userMediaConstraints) ||
      navigator.msGetUserMedia(userMediaConstraints);

    userMedia.then(stream => {
      this.videoStream.srcObject = stream;
      this.videoStream.play();
    });
  }

  stopStream() {
    return (
      this.videoStream &&
      this.videoStream.srcObject &&
      this.videoStream.srcObject.getTracks().map(track => track.stop())
    );
  }

  capture() {
    const {
      videoWidth,
      videoHeight,
      screenshotFormat,
      screenshotQuality,
      onCapture
    } = this.props;
    const context = this.canvas.getContext('2d');
    context.drawImage(this.videoStream, 0, 0, videoWidth, videoHeight);
    const image = this.canvas.toDataURL(screenshotFormat, screenshotQuality);

    onCapture(image);
  }

  render() {
    const { videoWidth, videoHeight } = this.props;

    return (
      <div className="Camera">
        <video
          ref={stream => {
            this.videoStream = stream;
          }}
          muted
          className="video"
          width={videoWidth}
        />
        <canvas
          ref={canvas => {
            this.canvas = canvas;
          }}
          className="canvas hidden"
          width={videoWidth}
          height={videoHeight}
        />
      </div>
    );
  }
}

export default Camera;



// WEBPACK FOOTER //
// ./src/components/Camera.js